export default () => {
  return (
    <div className='header-block'>
      <div className='header-logo'></div>
    </div>
  );
}